import * as React from "react";

function Landing() {
    return (
        <div className="flex flex-col justify-center text-white w-full ">
            <div className="flex overflow-hidden relative items-end px-6 md:px-12 lg:px-20 pt-6 pb-14 w-full min-h-[300px] md:min-h-[450px] lg:min-h-[550px] max-md:max-w-full">
                <img
                    loading="lazy"
                    src="/blog-banner.jpg"
                    alt="Background"
                    className="absolute inset-0 object-cover w-full h-full"
                />
                <div className="absolute inset-0 bg-black/20"></div>

                <div className="relative w-full max-w-7xl mx-auto pb-12 md:pb-20">
                    <h1 className="text-5xl md:text-7xl lg:text-8xl font-black text-white tracking-tight uppercase">
                        BLOGS
                    </h1>
                </div>
            </div>
        </div>
    );
}

export default Landing;
